<template>
    <div class="xero-wrap xero-wrap-mobile">
      <div class="logo"></div>
      <div class="clear">
          <div class='back_box' @click="prev">
              <i class="el-icon-back"></i> Back
          </div>
          <div class="pro">
              <template v-if="isPro">
                <div class="tit">2 / 3</div>
                <el-progress :percentage="66"></el-progress>
              </template>
              <template v-if="!isPro">
                <div class="tit">2 / 2</div>
                <el-progress :percentage="100"></el-progress>
              </template>
          </div>
      </div>
      <div class="title">Registered Peiso</div>
      <div class="bgd">
        <div class="con">
            <h1 class="title">Set Up App Account</h1>

            <div class="m-bottom-2rem">
                <div class="d-flex number-container" v-for="(item, i) in mobileLists" :key="`mobile-list${i}`">
                    <div class="border-1 p-8-all w-100">
                        <el-input v-model="item.name" class="peiso-input-default" placeholder="Name" :readonly="true"></el-input>
                    </div>
                    <div class="border-1 p-8-all w-100">
                        <el-input v-model="item.mobile" class="peiso-input-default" placeholder="Mobile Number" :readonly="true"></el-input>
                    </div>

                    <div class="border-1 p-8-all w-100">
                        <el-input v-model="item.emailAddress" class="peiso-input-default" :readonly="true"></el-input>
                    </div>

                    <div class="border-1 d-flex align-items-center px-1rem">
                        <el-button type="peiso-danger" @click="removeNumber(i)">-</el-button>
                    </div>
                </div>

                <div class="d-flex number-container field" v-if="!isHideForms">

                    <div class="border-1 p-8-all w-100">
                        <el-input v-model="name" class="peiso-input-default" :class="{'is-invalid' : isInvalid(name)}" placeholder="Name"></el-input>
                    </div>
                    <div class="border-1 p-8-all w-100">
                        <el-input v-model="mobile" class="peiso-input-default" :class="{'is-invalid' : isInvalid(mobile) || mobile.length < 9}" placeholder="Mobile Number" maxlength="11"></el-input>
                    </div>
                    <div class="border-1 p-8-all w-100">
                        <el-input v-model="emailAddress" class="peiso-input-default" type="email" placeholder="Email Address"></el-input>
                    </div>

                    <div class="border-1 p-8-all d-flex align-items-center px-1rem">
                        <el-button type="peiso-success" class="w-100" @click="addNumber()">+</el-button>
                    </div>

                </div>
            </div>

            <div class="btm-btns clear d-flex justify-content-center">
                <!-- <button v-if="isPro" class="next" @click="confirm" :class="{'disabled' : !mobileLists.length}" :disabled="mobileLists.length ? false : true">Next</button>
                <button class="skip" v-if="!mobileLists.length && isPro" @click="$router.replace('/pay')">Skip</button> -->
                <button class="next" @click="confirm">Create Venue</button>
            </div>

        </div>
      </div>

      <el-dialog title="" :visible.sync="loading" :modal-append-to-body="false" :show-close='false' class="modalMessageLoading">
        <modal-message-dialog :isLoading="loading" :isDoneLoading="doneLoading" :label="messageLabel" :subLabel="messageSubLabel"></modal-message-dialog>
      </el-dialog>

    </div>
  </template>

  <script>
  import utils from '@/utils/utils';
  import login from "@/api/login";
  import api from '../../api/xero'
  import modalMessageDialog from '../modal/messageDialog.vue';
  export default {

    data () {
      return {
        name: '',
        mobile: '',
        emailAddress: '',
        isComplete: false,
        mobileLists: [],
        isPro: false,
        loading: false,
        doneLoading: true,
        messageLabel: 'Loading...',
        messageSubLabel: 'Please wait as this process will take some time to complete.',
      }
    },
    created () {
        if (!sessionStorage.getItem('request_params')) {
            this.$router.replace('/welcome')
        } else {
          var register = JSON.parse(sessionStorage.getItem('request_params'))
          if (register.mobileLists) {
            this.mobileLists = register.mobileLists

          }
          if (register.isPro) {
            this.isPro = register.isPro
          }
        }
    },
    methods: {
        addNumber() {
            if (this.name == '' || this.mobile.length < 10 || this.mobile == '') {
              return
            }
            if (this.mobileLists.length) {
              var list = this.mobileLists
              list = list.filter((n) => n.mobile == this.mobile)

              if (list.length) {
                utils.alert2('Error', 'Mobile number already added', 'error')
                return
              }
            }
            this.mobileLists.push({
                name: this.name,
                mobile: this.mobile,
                emailAddress: this.emailAddress
            })

            this.name = ''
            this.mobile = ''
            this.emailAddress = ''
        },

        removeNumber(i) {
          this.mobileLists.splice(i, 1)
        },

        isInvalid(value) {
            return value != '' ? false : true
        },

        confirm() {
            let request_params = JSON.parse(sessionStorage.getItem('request_params'))
            let isPro = sessionStorage.getItem('isPro');

            // TODO: Disable the payment page for now
            // sessionStorage.removeItem('request_params')
            // sessionStorage.setItem('request_params', JSON.stringify(request_params))
            // this.$router.replace('/pay')

            // TODO: Redirect to the success page
            request_params.mobileLists = this.mobileLists

            request_params.cardName = null;
            request_params.cardNumber = null;
            request_params.cvv = null;
            request_params.expire = null;
            request_params.discountCode = null;
            request_params.monthlyFee = 0;

            this.loading = true;
            this.doneLoading = false;
            api.signUpWithXero({
              params: request_params,
              callback: async (res) => {
                if (res.data.code == 0) {
                  // this.$router.replace('/success')
                  let user = {
                    userName: request_params.userName,
                    password: request_params.password,
                  };
                  login.login(user, async (res) => {
                    var data = res.data.data;
                    if (res.data.code == 0) {
                      window.sessionStorage.setItem("token", data.token);
                      sessionStorage.setItem("venueType", 1);
                      sessionStorage.setItem("isPinNeeded", 1);
                      sessionStorage.setItem("isSingleAccount", 1);
                      sessionStorage.setItem("subVenueId", data.venueId);
                      sessionStorage.setItem("subVenueName", data.venueName);

                      if (request_params.mobileLists) {
                        for (var i = 0; i < request_params.mobileLists.length; i++) {
                          var mobile = request_params.mobileLists[i];
                          var params = {
                            fullName: mobile.name,
                            mobileNumber: mobile.mobile,
                            emailAddress: mobile.emailAddress,
                          };
                          await api.signUpaccountAddApi(params);

                          this.messageSubLabel = `Adding ${i + 1} out of ${request_params.mobileLists.length
                            } app accounts listed<br>Please wait as this process will take some time to complete.`;
                        }
                      }

                      if (isPro == 'true') {
                        // this.$router.replace("/success");
                        window.location.href = `${process.env.WEB_URL}/peiso-pro-thank-you-page`;
                      } else {
                        window.location.href = `${process.env.WEB_URL}/peiso-lite-thank-you-page`;
                      }

                      this.loading = false;
                      this.doneLoading = true;
                      // this.$router.replace('/success')
                    }
                  });
                } else {
                  Utils.alert2("", res.data.message, "error");
                  this.loading = false;
                  this.doneLoading = true;
                }
              },
            });

        },

        createLiteAccount() {
          var request_params = JSON.parse(sessionStorage.getItem('request_params'))

          request_params.mobileLists = this.mobileLists
          request_params.cardName = ''
          request_params.cardNumber = ''
          request_params.cvv = ''
          request_params.expire = ''
          request_params.discountCode = '7DAYSFREE'
          request_params.monthlyFee = 0

          sessionStorage.setItem('request_params', JSON.stringify(request_params))

          this.loading = true;
          this.doneLoading = false;
          api.signUpWithXero({
            params: request_params,
            callback: async (res) => {

              var data = res.data.data
              if (res.data.code == 0) {
                if (request_params.mobileLists) {
                  for (var i = 0; i < request_params.mobileLists.length; i++) {
                    var mobile = request_params.mobileLists[i]
                    var params = {
                      fullName: mobile.name,
                      mobileNumber: mobile.mobile,
                      emailAddress: mobile.emailAddress
                    }
                    await api.signUpaccountAddApi(params)

                    this.messageSubLabel = `Adding ${i+1} out of ${request_params.mobileLists.length} app accounts listed<br>Please wait as this process will take some time to complete.`

                  }
                }
                sessionStorage.removeItem('request_params')

                window.location.href = "https://peiso.com.au/peiso-lite-thank-you-page"


              } else {
                utils.alert2('', res.data.message, 'error')
              }
              this.loading = false;
              this.doneLoading = true;


            }
          })
        },


        prev () {
            this.$router.replace('/register')
        }
    },
    computed: {
      isHideForms() {
        var isHide = false
        if (!this.isPro && this.mobileLists.length >= 2) {
          isHide = true
        }

        return isHide
      }
    },
    components: {
      modalMessageDialog: modalMessageDialog
    }
  }
  </script>

  <style lang="scss" scoped>
  @import 'static/scss/colors.scss';
  @import 'static/scss/media-queries';
  .xero-wrap{
    color: var(--text-color);
    padding-bottom: 50px;
    min-width: 1200px;
    .bgd{
      width: 100%;
      background: var(--background-color-4);
      padding: 50px 0 65px 0;
      //margin-bottom: 50px;
      .con{
        width: 740px;
        margin: 0 auto;
        .btm-btns{
          width: 100%;
          margin: 0 auto;
          button{
            width: 280px;
            height: 60px;
            background: var(--background-color-4);
            float: left;
            box-sizing: border-box;
            font-size: 26px;
            cursor: pointer;
          }

          .disabled{
            border: 2px solid #8E3771 !important;
            color: #8E3771 !important;
            cursor: not-allowed;
          }
          .skip{
            border: 2px solid var(--text-color);
            font-family: PingFangSC-Semibold, PingFang SC;
            color: var(--text-color);
          }
          .next{
            margin-right: 50px;
            border: 2px solid #EA3796;
            font-family: PingFangSC-Semibold, PingFang SC;
            color: #EA3796;
          }
        }
        h1{
          font-family: 'PingFang SC-Medium';
          font-size: 30px;
          line-height: 42px;
          margin-bottom: 50px;
        }
        h2{
          font-size: 14px;
          line-height: 16px;
          margin-bottom: 10px;
        }
        .inputItem{
          width: 100%;
          margin-bottom: 30px;
          position: relative;
          input{
            outline: none;
            border: 1px solid rgba(95,95,95,1);
            background: var(--background-color-2);
            width: 100%;
            box-sizing: border-box;
            padding: 0 15px;
            font-family: 'SFProText-Regular';
            font-size: 20px;
            color: var(--text-color);
            height: 50px;
          }
          .el-input{
            outline: none;
            border: 1px solid rgba(95,95,95,1);
            background: var(--background-color-2);
            width: 100%;
            box-sizing: border-box;
            padding: 0 15px;
            font-family: 'SFProText-Regular';
            font-size: 20px;
            color: var(--text-color);
            height: 50px;
          }
          .lft{
            position: absolute;
            left: 20px;
            line-height: 50px;
            color: var(--text-color);
          }
          .rgt{
            position: absolute;
            right: 20px;
            line-height: 50px;
            color: var(--text-color);
          }


        }
        .radioItem{
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 41px;
          .radio{
            width: 355px;
            float: left;
            position: relative;
          }
          .el-input{
            width: 318px;
            height: 50px;
            outline: none;
            border: 1px solid rgba(95,95,95,1);
            background: var(--background-color-2);
            box-sizing: border-box;
            padding: 0 15px;
            font-family: 'SFProText-Regular';
            font-size: 20px;
            color: var(--text-color);
          }
          .radio:nth-child(1){
            margin-right: 30px;
            input{
              padding: 0 40px 0 15px;
            }
          }
          .radio:nth-child(2){
            input{
              padding: 0 15px 0 40px;
            }
          }
          .percentage{
            position: absolute;
            right: 20px;
            line-height: 50px;
            color: var(--text-color);
          }
          .dollar{
            position: absolute;
            left: 56px;
            line-height: 50px;
            color: var(--text-color);
          }
        }
        .dateItem{
          margin-bottom: 30px;
          position:relative;border-radius: 0;
          border: 1px solid var(--background-color-4);
          background-color: var(--background-color-2);
          height: 50px;
          color: var(--text-color);
          font-family: 'SFProText-Regular';
          font-size: 20px;
          color: var(--background-color-3);
          background-size: 23px 22px;
          background-position: 16px center;
          background-repeat: no-repeat;
          background-image: url('../../assets/c2.png');
        }
        .monItem{
          margin-bottom: 30px;
          position:relative;border-radius: 0;
          border: 1px solid var(--background-color-4);
          background-color: var(--background-color-2);
          height: 50px;
          color: var(--text-color);
          font-family: 'SFProText-Regular';
          font-size: 20px;
          color: var(--background-color-3);
          background-size: 23px 22px;
          background-position: 16px center;
          background-repeat: no-repeat;
          background-image: url('../../assets/c2.png');
        }
      }
    }

    .el-button {
        &--peiso-success, &--peiso-danger {
            font-size: 16px !important;
            display: flex;
            align-items: center;
            width: 43px;

        }


    }

    .number-container {
        .border-1 {
            border: 1px solid $gray1;
        }

        .mobile {
            width: 350px;
        }

        &.field {

          @include mobile-lg {
            flex-direction: column !important;
          }
        }
    }
  }

  .pro{
      margin-bottom: 30px;
      width: 200px;
      float: right;
      .tit{
          text-align: right;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #EA3796;
          line-height: 22px;
      }
  }
  .title{
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: var(--text-color);
      line-height: 33px;
      margin-bottom: 39px;
  }
  .back_box{
    float: left;
    width: 150px;
    font-size:14px;
    font-weight:600;
    color:var(--text-color);
    line-height:20px;
    cursor: pointer;
    .el-icon-back{
      margin-right: 10px;
      font-size: 20px;
      position: relative;
      top: 3px;
    }
  }

  </style>



// WEBPACK FOOTER //
// src/components/register/appAccount.vue